export * from './ClimbingBoxLoader.js';
